import { promises as fs } from "node:fs";
// Backup .claude/pack/ before `avatar sync --force` so user can `avatar restore`
// if the sync goes wrong. Naming convention: pack-{currentVersion}-{YYYYMMDD-HHmm}.
import { join } from "node:path";
import { copyDirRecursive, ensureDir, pathExists } from "./filesystem-helpers.js";

export const BACKUP_DIR_NAME = "_backup";

function timestamp(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  const h = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  return `${y}${m}${d}-${h}${min}`;
}

export function buildBackupName(currentVersion: string): string {
  // Strip any leading "v" so we don't get pack-vv1.2.3 if someone passes "v1.2.3".
  const cleanVersion = currentVersion.replace(/^v/, "");
  return `pack-v${cleanVersion}-${timestamp()}`;
}

// Backup .claude/pack/ to .claude/_backup/{name}/, excluding the submodule's
// own .git directory (we restore content only, not git history).
export async function backupPack(projectRoot: string, currentVersion: string): Promise<string> {
  const name = buildBackupName(currentVersion);
  const srcPath = join(projectRoot, ".claude", "pack");
  const dstPath = join(projectRoot, ".claude", BACKUP_DIR_NAME, name);
  if (!(await pathExists(srcPath))) {
    throw new Error("Không tìm thấy .claude/pack/ để backup");
  }
  await ensureDir(dstPath);
  await copyDirRecursive(srcPath, dstPath, [".git"]);
  return name;
}

export async function listBackups(projectRoot: string): Promise<string[]> {
  const dir = join(projectRoot, ".claude", BACKUP_DIR_NAME);
  if (!(await pathExists(dir))) return [];
  const entries = await fs.readdir(dir, { withFileTypes: true });
  return entries
    .filter((e) => e.isDirectory())
    .map((e) => e.name)
    .sort()
    .reverse();
}
